import { AppState } from '../root.reducer';
import { denormalize } from 'normalizr';
import SCHEMA from '../schema';
import { TenancyAnniversaryWithTenancyDTO } from '@reposit/api-client';

export const getAnniversaries = (state: AppState): TenancyAnniversaryWithTenancyDTO[] => {
  const ids = state.tenancyAnniversaries.anniversaries;
  return ids.map((id) => denormalize(state.entities.tenancyAnniversary[id], SCHEMA.tenancyAnniversary, state.entities));
};
